// extracted by mini-css-extract-plugin
module.exports = {"Checkbox":"AddLabelItem_Checkbox__x8yW7"};